import { PatientDataCompareKey } from './mapPatientDataToCompareTable.helper';

export const PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS: Record<
	PatientDataCompareKey,
	string
> = {
	salutation: 'base.shared.salutation',
	salutationBefore: 'base.shared.salutationBeforeName',
	firstName: 'base.shared.firstName',
	lastName: 'base.shared.lastName',
	salutationAfter: 'base.shared.salutationAfterName',
	'address.street': 'base.shared.street',
	'address.descriptiveNumber': 'base.shared.descriptiveNumber',
	'address.guideNumber': 'base.shared.guideNumber',
	'address.city': 'base.shared.city',
	'address.postCode': 'base.shared.postCode',
	insuranceNumber: 'base.shared.insuranceCardNumber',
	insuranceCompanyCode: 'base.shared.insuranceCompany',
};
